module.exports = __webpack_public_path__ + "img/initial.ac56341e.png";